import * as Yup from "yup";
import {INVALID_EMAIL_MESSAGE, REQUIRED_FIELD_MESSAGE} from "../../constants";

export const fairfaxTenantInputSectionYupSchema: Yup.ObjectSchema<FairfaxTenantInputSectionSchema> = Yup.object().shape({
  document: Yup.string()
    .required(REQUIRED_FIELD_MESSAGE)
    .isValidDocument(),
  name: Yup.string().required(REQUIRED_FIELD_MESSAGE),
  email: Yup.string().required(REQUIRED_FIELD_MESSAGE).isValidEmailWithoutAccents()
})

export type FairfaxTenantInputSectionSchema = {
  document: string;
  name: string;
  email: string;
}
